/* ==========================================================================
   easyToilet SOS — Bewegung für Variante A3.
   --------------------------------------------------------------------------
   Ein einziger IntersectionObserver für die ganze Seite. Die Ziele werden
   über ihre Klassen gefunden, NICHT über Attribute im Markup — so bleiben
   die geteilten Sections unverändert und a2 ohne jede Bewegung.

   Regeln, die hier gelten:
   - Nur opacity und transform, nie Layout-Eigenschaften.
   - Jede Bewegung läuft genau einmal; danach wird nicht mehr beobachtet.
   - Ohne JS oder bei „Bewegung reduzieren" ist alles sofort sichtbar:
     die Verstecken-Regeln hängen an .et3-js, das erst hier gesetzt wird.
   - Keine verschachtelten Ziele: ein Block, dessen Vorfahr schon animiert
     wird, bleibt außen vor — sonst überlagern sich zwei Transformationen.
   ========================================================================== */

(() => {
  /* Wer weniger Bewegung wünscht, bekommt gar keine — auch kein Verstecken. */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Reihenfolge = Vorrang: Was früher steht, gewinnt bei Verschachtelung.
     stufe = Verzögerung je Kind in Millisekunden. */
  const GRUPPEN = [
    /* Der Kopf jeder Section: die stille Grundbewegung der Seite. */
    { auswahl: '.et .et-kopf' },

    /* Die Wirkungskette baut sich Glied für Glied auf — das ist die eine
       Stelle, an der die Bewegung die Aussage selbst trägt. */
    { auswahl: '.et .et-ef3__blatt', kinder: '.et-ef3__knoten, .et-ef3__pfeil', stufe: 110 },

    /* Aufbau-Zeitschiene: die Linie zieht durch, die Zeitchips setzen sich
       nacheinander. Die Schritte selbst haben ihre eigene Hervorhebung. */
    { auswahl: '.et .et3-min__reihe', kinder: '.et3-min__chip', stufe: 90 },

    { auswahl: '.et .et3-plus__raster', kinder: '.et3-plus__text, .et3-plus__buehne', stufe: 120 },
    { auswahl: '.et .et3-quer__reihe', kinder: '.et3-quer__karte', stufe: 90 },
    { auswahl: '.et .et-c-wege', kinder: '.et-c-weg', stufe: 80 },

    /* Das Rechenergebnis: die Kostenbalken wachsen erst hier aus der Null. */
    { auswahl: '.et .et-c-ergebnis' },

    { auswahl: '.et .et-a2-blatt' },
    { auswahl: '.et .et-a2-innen__zeile' },
    { auswahl: '.et .et-daten' },
  ];

  const ziele = [];
  GRUPPEN.forEach((g) => {
    document.querySelectorAll(g.auswahl).forEach((el) => {
      /* Verschachtelung ausschließen: weder Kind noch Elternteil eines
         bereits gewählten Ziels. */
      if (ziele.some((z) => z === el || z.contains(el) || el.contains(z))) return;
      ziele.push(el);
      el.classList.add('et3-ruht');
      if (g.kinder) {
        /* Eigene Klasse statt :has() im CSS — deterministisch und ohne
           Rückfragen an die Browser-Unterstützung. */
        el.classList.add('et3-gruppe');
        el.querySelectorAll(g.kinder).forEach((k, i) => {
          k.classList.add('et3-kind');
          k.style.setProperty('--et3-stufe', Math.min(i, 9) * (g.stufe || 80) + 'ms');
        });
      }
    });
  });

  if (!ziele.length) return;

  /* Erst jetzt verstecken: bis hierher war alles sichtbar, falls das
     Skript gar nicht lädt. */
  document.documentElement.classList.add('et3-js');

  const zeige = (el) => {
    el.classList.add('et3-an');
    beobachter.unobserve(el);
  };

  const beobachter = new IntersectionObserver(
    (eintraege) => eintraege.forEach((e) => e.isIntersecting && zeige(e.target)),
    /* Startet, sobald der Block anläuft — nicht erst, wenn er halb gelesen ist. */
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  ziele.forEach((el) => beobachter.observe(el));

  /* Was beim Laden schon im Bild steht, wird sofort gezeigt — sonst wirkt
     es wie ein Ruckler direkt nach dem Seitenaufbau. */
  requestAnimationFrame(() => {
    ziele.forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) zeige(el);
    });
  });
})();
